export function removeEmptyObjects(obj) {
  for (const prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      if (typeof obj[prop] === "object") {
        obj[prop] = removeEmptyObjects(obj[prop]);
        if (Object.keys(obj[prop]).length === 0) {
          delete obj[prop];
        }
      } else if (
        obj[prop] === null ||
        obj[prop] === undefined ||
        obj[prop] === ""
      ) {
        delete obj[prop];
      }
    }
  }
  return obj;
}

export function removeEmpty(obj) {
  for (const key in obj) {
    if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
      delete obj[key];
    } else if (typeof obj[key] === "object") {
      removeEmpty(obj[key]);
    }
  }
  const newData = removeEmptyObjects(obj);
  return newData;
}
